import React from 'react';

const ArrowRightOpen = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 14" {...props}>
    <path
      fillRule="evenodd"
      d="M1.278 12.738a1.055 1.055 0 0 1 .008-1.443L5.17 7.24 1.286 3.185a1.057 1.057 0 0 1-.008-1.444l.034-.034a.944.944 0 0 1 1.376 0l4.624 4.816c.38.396.382 1.035 0 1.434l-4.624 4.816a.95.95 0 0 1-1.376 0l-.034-.035z"
    />
  </svg>
);

export default ArrowRightOpen;
